/* eslint-disable quotes */
/** On peut décomposer les routes par module**/
import Layout from "@/layout";

const animalsRoutes = {
  path: "/animals",
  component: Layout,
  redirect: "/animals/diseases",
  name: "Animals",
  // alwaysShow: true,
  meta: {
    title: "animals",
    icon: "animals",
    permissions: ["manage disease", "manage specie", "manage breed"],
  },
  children: [
    {
      path: "diseases",
      component: () =>
        import(/* webpackChunkName: "diseases" */ "@/views/diseases/index"),
      name: "diseases",
      meta: { title: "diseases", icon: "disease" },
    },
    {
      path: "species",
      component: () =>
        import(/* webpackChunkName: "species" */ "@/views/species/index"),
      name: "species",
      meta: { title: "species", icon: "cow" },
    },
    {
      path: "breeds",
      component: () =>
        import(/* webpackChunkName: "breeds" */ "@/views/breeds/index"),
      name: "breeds",
      meta: { title: "breeds", icon: "cow" },
    },
  ],
};

export default animalsRoutes;
